module.exports = __webpack_public_path__ + "static/media/bet-green-5.84787195.png";